<template>
  <section class="profile__block pattern">
    <div class="profile__block__header">
      <h2>{{ getTranslations.home_profile_profile_stats_your_status }}</h2>
    </div>
    <div class="profile__block__content profile__block__content--stats">
      <div class="profile__block__content__stats">
        <Stat :image="'static/images/rocket_mod.svg'"
              :text="getTranslations.home_profile_profile_level"
              :value="numberFormatting(userDetails.level)"
              :action-on-click="toggleLevelUp"/>
        <Stat :image="'static/images/trophy_mod.svg'"
              :text="getTranslations.home_profile_profile_points"
              :value="numberFormatting(userDetails.totalPointsEarned)"
              :action-on-click="null"/>
        <Stat :image="'static/images/unlocked_mod.svg'"
              :text="getTranslations.home_profile_unlocked_games"
              :value="numberFormatting(userDetails.availableGames || 0)"
              :action-on-click="toggleGamesLeft"/>
        <Stat :image="'static/images/game_mod.svg'"
              :text="getTranslations.home_profile_profile_games"
              :value="numberFormatting(userDetails.gamesPlayed)"
              :action-on-click="null"/>
        <Stat :image="'static/images/star_mod.svg'"
              :text="getTranslations.home_profile_favorite_players"
              :value="numberFormatting(getNumberOfFavoriteUsers())"
              :action-on-click="() => goTo('favorite-users')"/>
        <Stat :image="'static/images/achievement_mod.svg'"
              :text="getTranslations.home_profile_completed_achievements"
              :value="numberFormatting(userDetails.achievements)"
              :action-on-click="() => goTo('achievements')"/>
      </div>
    </div>
    <fade-transition>
     <profile-level-up :user-info="userDetails" v-if="showLevelUp" @close="toggleLevelUp"/>
     <component :is="currentGamesLeftModal"  v-if="showGamesLeftModal" @close="showGamesLeftModal = false"/>
    </fade-transition>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import Stat from '@/components/home/shared/Stat';
import ProfileLevelUp from '@/components/home/modals/profile/ProfileLevelUp';
import GamesLeft from '@/components/home/modals/profile/GamesLeft';
import ZeroBalance from '@/components/home/modals/profile/GamesLeftZeroBalance';
import FadeTransition from '@/components/home/modals/shared/FadeTransition';

export default {
  name: 'profile-stats',
  mixins: [NumbersFormattingMixin],
  data() {
    return {
      showLevelUp: false,
      currentGamesLeftModal: null,
      showGamesLeftModal: false,
    };
  },
  components: {
    ProfileLevelUp,
    GamesLeft,
    Stat,
    ZeroBalance,
    FadeTransition,
  },
  methods: {
    goTo(pageName) {
      this.$router.push({ name: pageName });
    },
    toggleLevelUp() {
      this.showLevelUp = !this.showLevelUp;
    },
    toggleGamesLeft() {
      this.showGamesLeftModal = true;
      if (this.userDetails.availableGames > 0) {
        this.currentGamesLeftModal = GamesLeft;
      } else {
        this.currentGamesLeftModal = ZeroBalance;
      }
    },
    getNumberOfFavoriteUsers() {
      return Object.values(this.favoriteUsers).filter(user => !user.blocked).length;
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('users', [
      'favoriteUsers',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/ProfileStats.vue